const ReportDispatchTypes = {
  1: 'DAY',
  3: 'NIGHT',
  5: 'GRAVEYARD',
  67: '5:45 - COASTWISE',
  68: '5:45 - SQUAMISH'
}

export const REPORT_DISPATCH_TYPES = Object.entries(ReportDispatchTypes).map(
  ([key, value]) => ({ code: key, display: value })
);

